<template>
    <div class="mainBox">
        <div class="mainTop">
            <div class="mtLeft">
                <img class="picturetwo" src="../assets/pictures/BNZN.png" alt="" />
                <div class="textLogo">
                    智能仓储管理系统
                </div>
            </div>
            <div class="mtCenter">
                <div class="fixed-text">
                    <el-button @click="WarehouseAreaOverview" style="font-size:  22px;color: #5f5d5d;" type="text">库区总览
                    </el-button>
                    <el-button @click="WarehouseManagement" style=" font-size: 22px;margin-left: 70px;color: #5f5d5d;"
                        type="text">库房管理</el-button>
                    <el-button style="font-size: 24px; margin-left: 70px;" type="text">
                        <p class="glowing-text">货架管理</p>
                    </el-button>
                </div>
            </div>
            <div class="mtRight">
                <el-button style="font-size:18px;color: #ffffff;" @click="home()" type="text">首页</el-button>
            </div>
        </div>
        <div class="mainBottom">
            <div class="mbLeft">
                <Card class="Cone">
                    <div
                        style="background-image: linear-gradient(to right, rgba(10, 252, 211,0.6), rgba(33, 37, 37, 0.1));height：25px；weight:10px;">
                        <p style="font-size:17px;color: #ffffff;">
                            库房概括
                        </p>
                    </div>
                    <div style="position: absolute;left: 5%;top: 19%;">
                        <p style="font-size:12px;color: #ffffff94; ">
                            实时库存数/件
                        </p>
                        <p style="font-size:25px;color: rgba(10, 252, 211,0.8);">
                            13360
                        </p>

                        <p style="font-size:12px;color: #ffffff94; ">
                            货架容量/m³
                        </p>
                        <p style="font-size:25px;color: rgba(10, 252, 211,0.8);">
                            60000
                        </p>
                    </div>
                    <div class="chartCircle">
                        <el-progress type="circle" :percentage="25" color="rgba(10, 252, 211,0.7)"
                            text-color=" #ffffff"></el-progress>
                        <p style="font-size:14px;color: #ffffff94;">
                            各货架利用率
                        </p>
                    </div>
                    <div style="position: absolute;top: 54%;;width: 100%;height: 50%;">
                        <div ref="chartOne" style="width: 100%;height:100%;">
                        </div>

                    </div>
                </Card>
                <Card class="Cone" style="height: 3rem;min-height: 250px;">
                    <div
                        style="background-image: linear-gradient(to right,rgba(10, 252, 211,0.6), rgba(33, 37, 37, 0.1));height：30px；weight:10px;">
                        <p style="font-size:17px;color: #ffffff;">
                            库货类型
                        </p>
                    </div>
                    <div class="ring"> </div>
                    <img style="position: absolute;top: 65%;left: 5.5%; " src="../assets/pictures/box.png">

                    <div class="square"
                        style="position: absolute;top: 40%;left: 52%; background-color:rgba(10, 252, 211,0.6); ">

                    </div>
                    <p style="position: absolute;top: 34%;left:58%; font-size:15px;color: #fffffffd;">左连接：127</p>
                    <p style="position: absolute;top: 44%;left: 58%; font-size:15px;color: #ffffff;">右连接：64</p>
                    <p style="position: absolute;top: 54%;left: 58%; font-size:15px;color: #ffffff;">机械臂：645</p>
                    <p style="position: absolute;top: 64%;left: 58%; font-size:15px;color: #ffffff;">操作轴：784</p>
                    <p style="position: absolute;top: 74%;left: 58%; font-size:15px;color: #ffffff;">其他：491</p>
                    <div class="square"
                        style="position: absolute;top: 50%;left: 52%; background-color:rgba(255, 255, 255, 0.979); ">
                    </div>

                    <div class="square"
                        style="position: absolute;top: 60%;left: 52%; background-color:rgba(255, 251, 8, 0.6); ">
                    </div>

                    <div class="square"
                        style="position: absolute;top: 70%;left: 52%; background-color:rgba(247, 7, 7, 0.6); ">
                    </div>

                    <div class="square"
                        style="position: absolute;top: 80%;left: 52%; background-color:rgba(223, 153, 2, 0.8); ">
                    </div>
                </Card>
                <Card class="Cone" style="height: 2.5rem;min-height: 200px;">
                    <div
                        style="background-image: linear-gradient(to right, rgba(10, 252, 211,0.8), rgba(33, 37, 37, 0.1));height：30px；weight:10px;">
                        <p style="font-size:17px;color: #ffffff;">
                            一周出库数量
                        </p>

                    </div>
                    <div style="position: absolute;top: 10%;">
                        <div ref="chartTwo" style="width: 4.5rem; height: 230%;">
                        </div>

                    </div>
                </Card>
            </div>
            <div class="mbCenter">
                <div>
                    <div v-for="(row, rowIndex) in this.numOne" :key="rowIndex" class="row">
                        <div v-for="(cell, colIndex) in 20" :key="colIndex" class="cell" @mouseover="showCard(cell, $event)"
                            @mouseout="hideCard">
                            {{ cell=cell + 20 * (row - 1) + num }}

                        </div>
                    </div>
                </div>
                <div class="pageY">
                    <div class="pagination-button" @click="shang">上一页</div>
                    <div class="pagination-info">第{{ page }}页</div>
                    <div class="pagination-button" @click="xia">下一页</div>
                </div>
                <div v-if="showCard" class="cardOne" :style="cardStyle">
                    <p>{{ activeCell }} ：产品名称：左连接</p>
                </div>
            </div>
            <div class="mbRight">
                <div >
            <p style="font-size:15px;color: #0efad3;">上一页</p>
            <p style="color: #f3f3f3;">区域1</p>
            <p style="color: #f3f3f3;">区域2</p>
            <p style="color: #f3f3f3;">区域3</p>
            <p style="color: #f3f3f3;">区域4</p>
            <p style="color: #f3f3f3;">区域5</p>
            <p style="color: #f3f3f3;">区域6</p>
            <p style="color: #f3f3f3;">区域7</p>
            <p style="color: #f3f3f3;">区域8</p>
            <p style="color: #f3f3f3;">区域9</p>
            <p style="color: #f3f3f3;">区域10</p>
            <p style="font-size:15px;color: #0efad3;">下一页</p>
            <p style="font-size:5px;color: #35a18f;">第10页</p>
          </div>
            </div>
        </div>
    </div>
</template>
<script>
import Card from './One.vue'; // 导入Card组件
import * as echarts from 'echarts'
import './macarons.js'
export default {
    data() {
        return {
            numOne: 15,
            num: 0,
            page: 1,
            showingCard: false, // 控制是否显示卡片
            activeCell: '', // 存储当前鼠标悬浮的块
            cardStyle: {}, // 用于设置卡片的位置
        }
    },
    components:
    {
        Card, // 注册Card组件
    },
    mounted() {
        this.$nextTick(function () {
            this.ChartOne();
            this.ChartTwo();
        });

    },
    methods: {
        shang() {
            //如果是第一页，那么不能上一页
            if (this.page === 1) {

            } else {
                this.page = this.page - 1;
                this.num = this.num - 300;

            }
        },
        xia() {
            this.page = this.page + 1;
            this.num = this.num + 300;





        },
        showCard(cell, event) {
            this.activeCell = cell;
            this.showingCard = true;

            // 设置卡片的位置，使其跟随鼠标移动
            this.cardStyle = {
                top: `${event.clientY}px`,
                left: `${event.clientX + 10}px`, // 可以根据需要调整偏移量
            };
        },
        hideCard() {
            this.showingCard = false;
        },
        home() {
            this.$router.push("/common")
        },
        WarehouseManagement() {
            window.open(`${this.$qian}WarehouseManagement`, '_blank')
            // window.open('http://120.46.209.88:3455/#/WarehouseManagement', '_blank')
        },
        WarehouseAreaOverview() {
            window.open(`${this.$qian}WarehouseAreaOverview`, '_blank')
            // window.open('http://120.46.209.88:3455/#/WarehouseAreaOverview', '_blank')
        },
        ChartOne() {
            const myChart = echarts.init(this.$refs.chartOne)
            let dataAxis = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];
            // prettier-ignore
            let data = [90, 149, 210, 122, 133, 334, 198, 123, 125, 220];
            let yMax = 500;
            let dataShadow = [];
            for (let i = 0; i < data.length; i++) {
                dataShadow.push(yMax);
            }

            const option = {
                title: {

                },
                xAxis: {
                    data: dataAxis,
                    axisLabel: {
                        color: '#fff'
                    },
                    axisLine: {
                        show: true, // 显示 x 轴坐标轴线
                        lineStyle: {
                            color: '#fff' // x 轴坐标轴线颜色
                        }
                    },
                    z: 444
                },
                yAxis: {
                    axisLabel: {
                        color: '#fff'
                    }, splitLine: {
                        show: false // 禁用 x 轴分隔线
                    },
                },
                axisLine: {
                    show: true, // 显示 y 轴坐标轴线
                    lineStyle: {
                        color: '#fff' // y 轴坐标轴线颜色
                    }
                },
                dataZoom: [
                    {
                        type: 'inside'
                    }
                ],
                series: [
                    {
                        type: 'bar',

                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#FFFFF7' },
                                { offset: 0.7, color: '#6EF0DA' },
                                { offset: 1, color: '#33FFCC' }
                            ])
                        },
                        emphasis: {
                            itemStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    { offset: 0, color: '#70F4DD' },
                                    { offset: 0.7, color: '#6EF0DA' },
                                    { offset: 1, color: '#33FFCC' }
                                ])
                            }
                        },
                        data: data
                    }
                ]
            };

            myChart.setOption(option);

        },
        ChartTwo() {
            const myChart = echarts.init(this.$refs.chartTwo)
            const option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: [820, 932, 901, 934, 1290, 1330, 1320],
                        type: 'line',
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: 'rgba(33, 37, 37, 0.1)' },   // 渐变起始颜色
                                { offset: 1, color: 'rgba(10, 252, 211,0.8)' }    // 渐变结束颜色
                            ])
                        }
                    }
                ]
            };

            myChart.setOption(option);


        },
    }
}
</script>
<style scoped lang="less">
.mainBox {
    // position: absolute;
    // width: 100%;
    // height: 100%;
    background: linear-gradient(to bottom, #e0e0e0, #525252);

    .mainTop {
        width: 100%;
        height: 1.25rem;
        // background-color: pink;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        box-sizing: border-box;

        .mtCenter {
            transform: translateX(-0.35rem);
        }

        .mtLeft {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .picturetwo {
            width: .875rem;
        }

        .textLogo {
            color: #14d8d8;
            /* 文字颜色 */
            font-size: 0.5rem;
            margin-left: 10px;
        }

        .glowing-text {
            font-size: 30px;
            /* 设置文字大小 */
            text-shadow: 0 0 10px rgb(0, 213, 228);
            /* 添加发光效果，可以根据需要调整发光效果的大小和颜色 */
            color: #03dac8;
            /* 设置文字颜色 */
        }
    }

    .mainBottom {
        display: flex;

        .mbLeft {
            flex: 5;
            // background-color: #03dac8;
            padding: 0 5px;
            box-sizing: border-box;

            .Cone {
                height: 5.75rem;
                min-width: 307px;
                margin-bottom: 5px;
                position: relative;
            }

            .chartCircle {
                position: absolute;
                top: 22%;
                left: 50%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            @keyframes spin {
                1% {
                    transform: rotate(0deg);
                }

                100% {
                    transform: rotate(360deg);
                }
            }

            .ring {
                width: 1.3rem;
                height: 1.3rem;
                border: 30px solid transparent;
                /* 外圆 */
                border-top-color: rgb(40, 240, 206);
                /* 环的颜色 */
                border-radius: 100%;
                animation: spin 0.6s linear infinite;
                /* 环旋转动画 */
            }

            .square {
                width: 5px;
                height: 17px;
                /* 设置背景颜色 */
            }

        }

        .mbCenter {
            flex: 16;
            // background-color: pink;
            padding: 10px;
            box-sizing: border-box;

            .row {
                display: flex;
            }

            .cell {
                width: 0.58rem;
                height: 0.58rem;
                border: 5px solid #ffffffc2;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 0.28rem;
                margin: 0.0625rem;
                // background: linear-gradient(to right, #0efad3, #03dac8);
                background: #9b7202ce;
                /* 使用渐变背景 */
                color: #fff;
                /* 设置文字颜色为白色 */
                // box-shadow: 0 0 10px rgba(14, 250, 211, 0.7);
                box-shadow: 0 0 10px #9b7202ce;
                /* 添加发光效果 */
                animation: glow 1.5s alternate infinite;
                /* 添加闪烁动画 */
                transform: translateZ(5px);
                /* 添加立体感 */
            }

            .cardOne {
                position: absolute;
                background-color: #fff;
                border: 1px solid #ccc;
                padding: 10px;
                box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
                /* 可以根据需要调整样式 */
            }

            .pageY {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 0.25rem;
            }

            .pagination-button {
                font-size: 20px;
                color: #0efad3;
                cursor: pointer;
           
            }

            .pagination-info {
                font-size: 16px;
                color: #35a18f;
                margin: 5 20px;
                margin-left: 15px;
                margin-right: 15px;
            }
        }

        .mbRight {
            flex: 3;
            // background-color: blue;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}</style>